export default {
  movements: state => state.movements,
  isCallingMovements: state => state.isCallingMovements,
  movementsCurrentPage: state => state.movementsCurrentPage,
  movementsLastPage: state => state.movementsLastPage,
  isCallingOffice: state => state.isCallingOffice,
  officeBalanceInformation: state => state.officeBalanceInformation,
  expenseDashboardData: state => state.expenseDashboardData,
  expenseDataFilters: state => state.expenseDataFilters,
  isCallingTokenizedCards: state => state.isCallingTokenizedCards,
  tokenizedCards: state => state.tokenizedCards

}
